"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAffordableAssetFields = void 0;
var entities_1 = require("@common/entities");
var COMMON_ADDRESS_FIELDS_1 = require("../COMMON_ADDRESS_FIELDS");
var getAffordableAssetFields = function (assetType, customType) {
    if (customType === void 0) { customType = entities_1.AssetTypes.CheckingAccount; }
    switch (customType) {
        case entities_1.AssetTypes.CheckingAccount:
        case entities_1.AssetTypes.SavingsAccount:
        case entities_1.AssetTypes.CertificateOfDeposit:
        case entities_1.AssetTypes.StocksOrBonds:
        case entities_1.AssetTypes.RetirementAccount:
        case entities_1.AssetTypes.MutualFunds:
        case entities_1.AssetTypes.TrustAccounts:
        case entities_1.AssetTypes.CashOnHand:
        case entities_1.AssetTypes.LifeInsurance:
        case entities_1.AssetTypes.OtherAssets:
        case entities_1.AssetTypes.PropertyAsInvestment:
        case entities_1.AssetTypes.RealEstateSale:
        case entities_1.AssetTypes.RealEstateRent:
        case entities_1.AssetTypes.RealEstateEquity:
            return __spreadArray(__spreadArray([
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Bank/Institution Name',
                    name: entities_1.IncomeFields.institutionName.name,
                    required: true,
                    sequence: 1,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.Text,
                    enabled: true,
                    label: 'Bank/Institution Contact Person',
                    name: entities_1.IncomeFields.contactName.name,
                    required: true,
                    sequence: 2,
                    type: entities_1.FieldType.Text,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Bank/Institution Contact Phone',
                    name: entities_1.IncomeFields.contactPhone.name,
                    required: true,
                    sequence: 3,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.PhoneNumber,
                    enabled: true,
                    label: 'Bank/Institution Contact Fax',
                    name: entities_1.IncomeFields.contactFax.name,
                    required: true,
                    sequence: 4,
                    type: entities_1.FieldType.PhoneNumber,
                },
                {
                    customType: entities_1.FieldType.Email,
                    enabled: true,
                    label: 'Bank/Institution Contact Email',
                    name: entities_1.IncomeFields.contactEmail.name,
                    required: true,
                    sequence: 5,
                    type: entities_1.FieldType.Email,
                }
            ], (0, COMMON_ADDRESS_FIELDS_1.getCommonAddressFields)(6), true), [
                {
                    customType: entities_1.FieldType.TextArea,
                    enabled: true,
                    label: 'Description',
                    name: entities_1.IncomeFields.description.name,
                    required: true,
                    sequence: 13,
                    type: entities_1.FieldType.TextArea,
                },
                {
                    customType: entities_1.FieldType.File,
                    enabled: true,
                    label: 'Upload Proof of Assets',
                    name: "applicant_".concat(assetType, "_asset_document_upload"),
                    required: true,
                    sequence: 14,
                    type: entities_1.FieldType.File,
                },
            ], false);
        default:
            return [];
    }
};
exports.getAffordableAssetFields = getAffordableAssetFields;
